import React, { useMemo } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function ThemeFrequencies({themeSignificance} :any) {
  const data = useMemo(() => ({
    labels: ["Information Clarity", "Cognitive Load Reduction", "Appointment Prep" , "Decision Confidence"],
    datasets: [
      {
        data: [60, 65, 70,50],
        backgroundColor: ["#9ad363", "#679437", "#3d5f1f"],
        borderWidth: 0,
        cutout: "55%",
      },
    ],
  }), []);

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,

    animation: {
      duration: 1500,
      easing: "easeOutQuart" as const, 
    },

    plugins: {
      legend: {
        display: false,
      },
    },
  }), []);

  const formatKey = (key: string) => {
    // Convert backend keys to human-friendly titles
    const keyMap: Record<string, string> = {
      high_impact_themes: "High Impact Themes",
      emotionally_charged_themes: "Emotionally Charged Themes",
      future_opportunities: "Future Opportunities",
    };
    return keyMap[key] || key;
  };

  return (
    <div className="flex flex-col h-full items-center w-full">
      <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-4 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">
        Theme Frequency & Intensity Matrix
      </h1>

      <div className="grid grid-cols-2 gap-2 w-full">
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-1">
      {Object.entries(themeSignificance).map(([key, items]:any) => (
        <div
          key={key}
          className="bg-[#9ADC54] border border-[#FFF7CE] rounded-md p-2"
        >
          <ul>
            <li>
              <strong className="text-lg">{formatKey(key)}</strong>
              <ul className="list-inside pl-1 flex flex-col gap-1">
                <li>
                  <ul className="list-disc pl-3">
                    {items.map((item: string, index: number) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ))}
    </div>

       


        <div className="flex flex-col items-center">
            <h4 className="text-black font-semibold mb-2 text-xl max-w-4xl text-center">Impact Metrics</h4>
            <div className="relative mt-3 h-full w-[400px]">          
            <Bar data={data} options={options}/>
        </div>
        </div>

      </div>

      
    </div>
  );
}
